import styled from 'styled-components';

import ImageSvg from '@web/assets/svg/images/projected-sales-announcement-modal.svg';

export const Image = styled(ImageSvg)`
  margin-top: 20px;
`;
